
const state = {
  isMobile:false,

}

const actions = {
    async setIsMobile({ dispatch, state, commit }, data) {
        commit('SET_MOBILE', data);

    }
}

const mutations = {
  SET_MOBILE(state, data) {
    state.isMobile = data;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
